// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"G_cQ","breadcrumbs__link":"G_cR","breadcrumbs__link__active":"G_cS","breadcrumbs__span":"G_cT"};